import { configureStore, StateFromReducersMapObject } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import userProfileReducer from './slices/userProfile'
import { authApi } from './apis/auth'
import { schemasApi } from './apis/schemas'
import { scenesApi } from './apis/scenes'
import { placesApi } from './apis/places'
import { sceneGroupsApi } from './apis/sceneGroups'
import { usersApi } from './apis/users'
import { developerApi } from './apis/developer'
import { timeslotsApi } from './apis/timeslots'

const reducer = {
  userProfile: userProfileReducer,
  [authApi.reducerPath]: authApi.reducer,
  [schemasApi.reducerPath]: schemasApi.reducer,
  [sceneGroupsApi.reducerPath]: sceneGroupsApi.reducer,
  [scenesApi.reducerPath]: scenesApi.reducer,
  [placesApi.reducerPath]: placesApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [developerApi.reducerPath]: developerApi.reducer,
  [timeslotsApi.reducerPath]: timeslotsApi.reducer,
}

export function createStore() {
  const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        authApi.middleware,
        schemasApi.middleware,
        sceneGroupsApi.middleware,
        scenesApi.middleware,
        placesApi.middleware,
        usersApi.middleware,
        developerApi.middleware,
        timeslotsApi.middleware,
      ),
  })

  return store
}

const store = createStore()
export default store

export type RootState = StateFromReducersMapObject<typeof reducer>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
